import React from 'react';
import OurTeam from '../Pages/OurTeam';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Projects from '../Pages/Projects';
import SupportRequest from '../Pages/SupportRequest';
import Contact from '../Pages/Contact';
import Login from '../Pages/Login';
import AdminLogin from '../Pages/AdminLogin';
import OnePage from '../Pages/OnePage';
import ProtectedRoutes from './ProtectedRoutes';
import AdminRoutes from './AdminRoutes';
import AdminDashboard from '../Pages/AdminPages/Dashboard';
import UserRoutes from './UserRoutes';
import UserDashboard from '../Pages/UserPages/Dashboard';
import AdminList from '../Pages/AdminPages/UserList';
import AdminSingle from '../Pages/AdminPages/UserSingle';
import AdminNewUpdate from '../Pages/AdminPages/UserNewUpdate';
import PhotoList from '../Pages/UserPages/PhotoList';
import AlbumList from '../Pages/UserPages/AlbumList';
import PhotoSingle from '../Pages/UserPages/PhotoSingle';
import AlbumSingle from '../Pages/UserPages/AlbumSingle';
import PhotoNewUpdate from '../Pages/UserPages/PhotoNewUpdate';
import AlbumNewUpdate from '../Pages/UserPages/AlbumNewUpdate';
import AlbumPhotoNewUpdate from '../Pages/UserPages/AlbumPhotoNewUpdate';
import UserProfileEdit from '../Pages/UserPages/UserProfileEdit';
import UserProfile from '../Pages/UserPages/UserProfile';
import { userInputs } from '../data/formSource';
import UserStats from '../Pages/UserPages/UserStats';
import UserNotifications from '../Pages/UserPages/UserNotifications';
import AdminProfile from '../Pages/AdminPages/AdminProfile';
import AdminProfileEdit from '../Pages/AdminPages/AdminProfileEdit';
import AdminStats from '../Pages/AdminPages/AdminStats';
import AdminPhotos from '../Pages/AdminPages/AdminPhotos';
import AdminPhotoSingle from '../Pages/AdminPages/AdminPhotoSingle';
import AdminPhotoUpdate from '../Pages/AdminPages/AdminPhotoUpdate';
import AdminAlbums from '../Pages/AdminPages/AdminAlbums';
import AdminAlbumSingle from '../Pages/AdminPages/AdminAlbumSingle';
import AdminAlbumUpdate from '../Pages/AdminPages/AdminAlbumUpdate';

function AnimatedRoutes({ isMobile }) {
  const location = useLocation();

  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route
          path="/"
          element={
            <UserRoutes>
              <OnePage />
            </UserRoutes>
          }
        />
        <Route
          path="/ourteam"
          element={
            <UserRoutes>
              <OurTeam />
            </UserRoutes>
          }
        />
        <Route
          path="/projects"
          element={
            <UserRoutes>
              <Projects />
            </UserRoutes>
          }
        />
        <Route
          path="/supportrequest"
          element={
            <UserRoutes>
              <SupportRequest />
            </UserRoutes>
          }
        />
        <Route
          path="/contact"
          element={
            <UserRoutes>
              <Contact />
            </UserRoutes>
          }
        />
        <Route path="/login" element={<Login inputs={userInputs} />} />

        <Route path="/adminlogin" element={<AdminLogin inputs={userInputs} />} />

        <Route path=":userId/photos">
          <Route
            index
            element={
              <ProtectedRoutes>
                <PhotoList title="Photos" isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
          <Route
            path=":photoId"
            element={
              <ProtectedRoutes>
                <PhotoSingle isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
          <Route
            path="new"
            element={
              <ProtectedRoutes>
                <PhotoNewUpdate title="Add new photo" isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />

          <Route
            path="update/:photoId"
            element={
              <ProtectedRoutes>
                <PhotoNewUpdate title="Update photo" isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
        </Route>
        <Route path=":userId/albums">
          <Route
            index
            element={
              <ProtectedRoutes>
                <AlbumList title="Albums" isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
          <Route
            path=":albumId"
            element={
              <ProtectedRoutes>
                <AlbumSingle isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
          <Route
            path="new"
            element={
              <ProtectedRoutes>
                <AlbumNewUpdate title="Add new album" isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
          <Route
            path=":albumId/new"
            element={
              <ProtectedRoutes>
                <AlbumPhotoNewUpdate title="Add new photo" isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
          <Route
            path="update/:albumId"
            element={
              <ProtectedRoutes>
                <AlbumNewUpdate title="Update album" isMobile={isMobile} />
              </ProtectedRoutes>
            }
          />
        </Route>

        <Route
          path=":userId/dashboard"
          element={
            <ProtectedRoutes>
              <UserDashboard title="Dashboard" isMobile={isMobile} />
            </ProtectedRoutes>
          }
        />

        <Route
          path=":userId/profile"
          element={
            <ProtectedRoutes>
              <UserProfile title="Profile" isMobile={isMobile} />
            </ProtectedRoutes>
          }
        />
        <Route
          path=":userId/update"
          element={
            <ProtectedRoutes>
              <UserProfileEdit title="Update user" isMobile={isMobile} />
            </ProtectedRoutes>
          }
        />

        <Route
          path=":userId/stats"
          element={
            <ProtectedRoutes>
              <UserStats title="Stats" isMobile={isMobile} />
            </ProtectedRoutes>
          }
        />
        <Route
          path=":userId/notifications"
          element={
            <ProtectedRoutes>
              <UserNotifications title="Notifications" isMobile={isMobile} />
            </ProtectedRoutes>
          }
        />

        <Route
          path="/admin/dashboard"
          element={
            <AdminRoutes>
              <AdminDashboard title="Dashboard" isMobile={isMobile} />
            </AdminRoutes>
          }
        />

        <Route
          path="/admin/stats"
          element={
            <AdminRoutes>
              <AdminStats title="Stats" isMobile={isMobile} />
            </AdminRoutes>
          }
        />
        <Route path="/admin/photos">
          <Route
            index
            element={
              <AdminRoutes>
                <AdminPhotos title="Photos" isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path="userId/:photoId"
            element={
              <AdminRoutes>
                <AdminPhotoSingle isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path="userId/update/:photoId"
            element={
              <AdminRoutes>
                <AdminPhotoUpdate isMobile={isMobile} />
              </AdminRoutes>
            }
          />
        </Route>

        <Route path="/admin/albums">
          <Route
            index
            element={
              <AdminRoutes>
                <AdminAlbums title="Albums" isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path=":albumId"
            element={
              <AdminRoutes>
                <AdminAlbumSingle isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path=":albumId/update"
            element={
              <AdminRoutes>
                <AdminAlbumUpdate isMobile={isMobile} />
              </AdminRoutes>
            }
          />
        </Route>

        <Route
          path="/admin/profile"
          element={
            <AdminRoutes>
              <AdminProfile title="Profile" isMobile={isMobile} />
            </AdminRoutes>
          }
        />
        <Route
          path="/admin/profile/update"
          element={
            <AdminRoutes>
              <AdminProfileEdit title="Update admin" isMobile={isMobile} />
            </AdminRoutes>
          }
        />

        <Route path="admin/users">
          <Route
            index
            element={
              <AdminRoutes>
                <AdminList title="Users" isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path=":userId"
            element={
              <AdminRoutes>
                <AdminSingle title="User Details" isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path=":userId/:photoId"
            element={
              <AdminRoutes>
                <AdminPhotoSingle isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path=":userId/update/:photoId"
            element={
              <AdminRoutes>
                <AdminPhotoUpdate isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path="new"
            element={
              <AdminRoutes>
                <AdminNewUpdate title="Add new user" isMobile={isMobile} />
              </AdminRoutes>
            }
          />
          <Route
            path="update/:userId"
            element={
              <AdminRoutes>
                <AdminNewUpdate title="Update user" isMobile={isMobile} />
              </AdminRoutes>
            }
          />
        </Route>
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
